import lockIcon from '@jetbrains/icons/lock.svg'
import ErrorMessage from '@jetbrains/ring-ui/components/error-message/error-message'
import Icon from '@jetbrains/ring-ui/components/icon/icon'
import classNames from 'classnames'

import {getPipelinesHref} from '../../../../routes'
import createPipelineImage from '../../../../svg/create-pipeline-image.svg'
import Loader from '../../../common/Loader/Loader'
import Link from '../components/Link/Link'
import RestScreenHeight from '../components/RestScreenHeight/RestScreenHeight'
import usePermissionCanEditProject from '../hooks/usePermissionCanEditProject'
import usePipelineDocumentTitle from '../hooks/usePipelineDocumentTitle'
import {isSpaceConnectionEnabled} from '../utils/featureToggles'

import CreatePipelineHeader from './CreatePipelineHeader/CreatePipelineHeader'
import useCreatePipeline from './hooks/useCreatePipeline'
import GitHubRepositories from './Repositories/GitHubRepositories.container'
import SpaceRepositories from './Repositories/SpaceRepositories.container'

import styles from './CreatePipelinePage.css'

function CreatePipelinePage() {
  const canEditProject = usePermissionCanEditProject()
  const {createPipeline, pipelineCreating} = useCreatePipeline()

  usePipelineDocumentTitle('Create')

  return (
    <RestScreenHeight>
      {pipelineCreating && (
        <div className={styles.loader}>
          <Loader />
        </div>
      )}
      {canEditProject ? (
        <div className={classNames(styles.container, {[styles.hidden]: pipelineCreating})}>
          <CreatePipelineHeader />
          <div className={styles.content}>
            {isSpaceConnectionEnabled ? (
              <SpaceRepositories onSelect={createPipeline} />
            ) : (
              <GitHubRepositories onSelect={createPipeline} />
            )}
            <div className={styles.imageWrapper}>
              <Icon glyph={createPipelineImage} className={styles.image} />
            </div>
          </div>
        </div>
      ) : !canEditProject ? (
        <div className={styles.errorWrapper}>
          <ErrorMessage
            icon={lockIcon}
            message="Access denied"
            description="You do not have enough permissions to create new pipeline"
          >
            <Link to={getPipelinesHref()}>{'Go to the home page'}</Link>
          </ErrorMessage>
        </div>
      ) : null}
    </RestScreenHeight>
  )
}

export default CreatePipelinePage
